import { Box, Text, Row, Pressable } from 'native-base'
import React from 'react'
import { ScrollView } from 'react-native'

import { Chip } from './Chip'
import { DraggableScrollView } from './DraggableScrollWiev'
import { Icon } from './Icon'
import { Spacer } from './atoms'

import { FILTER_TYPES } from '~constants'
import { CategoryType, initCoinRange, initPickerValue } from '~contexts'
import { dispatchType } from '~filtersReducer'
import {
  useCallback,
  useDeviceInfo,
  useFilters,
  useGetPickedFilters,
  useMemo,
  useTranslation,
} from '~hooks'
type FiltersBarType = {
  onPress: () => void
}

export type FilterType = {
  filterType:
    | typeof FILTER_TYPES.COIN_RANGE
    | typeof FILTER_TYPES.LOCATION
    | typeof FILTER_TYPES.OFFER_STATUS
  label: string
}

export type CheckBoxType = CategoryType & {
  filterType: typeof FILTER_TYPES.CHECKBOX
}

export const FiltersBar = ({ onPress }: FiltersBarType) => {
  const { filtersState, filtersDispatch } = useFilters()
  const { t } = useTranslation()
  const { pickedFilters } = useGetPickedFilters()
  const { isWeb } = useDeviceInfo()
  const deleteFilterHandler = useCallback(
    (filter: CheckBoxType | FilterType) => {
      if (filter.filterType === FILTER_TYPES.CHECKBOX) {
        const changedFiltersList = filtersState.categoriesList.map((el) => {
          if (el.value === filter.value) {
            return { ...el, isChecked: false }
          }
          return el
        })
        filtersDispatch({ type: dispatchType.UPDATE_CATEGORIES_LIST, payload: changedFiltersList })
      }
      if (filter.filterType === FILTER_TYPES.COIN_RANGE) {
        filtersDispatch({ type: dispatchType.UPDATE_COIN_RANGE, payload: initCoinRange })
      }
      if (filter.filterType === FILTER_TYPES.LOCATION) {
        filtersDispatch({
          type: dispatchType.UPDATE_SELECTED_LOCATION,
          payload: initPickerValue,
        })
      }
      if (filter.filterType === FILTER_TYPES.OFFER_STATUS) {
        filtersDispatch({
          type: dispatchType.UPDATE_SELECTED_OFFER_STATUS,
          payload: initPickerValue,
        })
      }
    },
    [filtersDispatch, filtersState.categoriesList]
  )

  const filtersToRender = useMemo(() => {
    const selectedFilters = pickedFilters?.map((el, index) => {
      return (
        <Box pr="2" key={index}>
          <Chip // eslint-disable-next-line react/jsx-no-bind
            onPress={() => deleteFilterHandler(el)}
            text={el.label}
          />
        </Box>
      )
    })
    if (isWeb) {
      return (
        <DraggableScrollView
          showsHorizontalScrollIndicator={false}
          horizontal={true}
          scrollEventThrottle={16}
        >
          {selectedFilters}
        </DraggableScrollView>
      )
    }
    return (
      <ScrollView showsHorizontalScrollIndicator={false} horizontal={true}>
        {selectedFilters}
      </ScrollView>
    )
  }, [deleteFilterHandler, isWeb, pickedFilters])

  return (
    <Row alignItems="center" flex={isWeb ? 1 : 0}>
      <Pressable onPress={onPress} py="1.5">
        <Row alignItems="center">
          <Icon name="equalizer-line" size={20} />
          <Spacer x="1" />
          <Text bold color="actionBlue" fontSize="md">
            {t('offers_list_screen.filter')}
          </Text>
        </Row>
      </Pressable>
      <Spacer x="2" />
      {filtersToRender}
      <Spacer x="1" />
    </Row>
  )
}
